import { Empty, Flex } from "antd";
import { useTranslation } from "react-i18next";
import { NutritionInfo } from "../../../components/NutritionInfo.tsx";
import { formatNumber } from "../../../utils/nutritionFormat.ts";
import { useRecipe } from "../RecipeContext.tsx";

export const RecipeNutritionTab = () => {
  const { t, i18n } = useTranslation();
  const { recipe } = useRecipe();
  const np = recipe.nutritionProfile;

  if (!np) {
    return <Empty description={t("recipes.nutrition.noData")} />;
  }

  const lang = i18n.language;

  return (
    <Flex gap="large" wrap>
      <NutritionInfo nutritionProfile={np} title={t("recipes.nutrition.perHundredGrams")} />
      {recipe.nutritionPerServing ? (
        <NutritionInfo
          nutritionProfile={recipe.nutritionPerServing}
          title={t("recipes.nutrition.perServing", { grams: formatNumber(recipe.servingSize ?? 0, lang, 0) })}
        />
      ) : null}
      {recipe.nutritionPerPackage ? (
        <NutritionInfo
          nutritionProfile={recipe.nutritionPerPackage}
          title={t("recipes.nutrition.perPackage", { grams: formatNumber(recipe.netWeight ?? 0, lang, 0) })}
        />
      ) : null}
    </Flex>
  );
};
